import { Container, clx } from "@modules/common/components/ui"
import Image from "next/image"
import React from "react"

import PlaceholderImage from "@modules/common/icons/placeholder-image"

type ThumbnailProps = {
  thumbnail?: string | null
  images?: { url?: string }[] | null
  size?: "small" | "medium" | "large" | "full" | "square"
  isFeatured?: boolean
  isCompact?: boolean
  className?: string
  "data-testid"?: string
}

const Thumbnail: React.FC<ThumbnailProps> = ({
  thumbnail,
  images,
  size = "small",
  isFeatured,
  isCompact,
  className,
  "data-testid": dataTestid,
}) => {
  const firstImage = thumbnail || images?.[0]?.url
  const secondImage = images?.[1]?.url

const backendUrl =
  process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL ||
  "https://api.legendarystore.online"

const fixImageUrl = (url?: string | null) => {
  if (!url) return undefined

  return url
    .replace(/^http:\/\/localhost:9000(?=\/|$)/, backendUrl)
    .replace(/^http:\/\/127\.0\.0\.1:9000(?=\/|$)/, backendUrl)
    .replace(/^http:\/\/192\.168\.1\.\d+:9000(?=\/|$)/, backendUrl)
}

const fixedFirstImage = fixImageUrl(firstImage)
const fixedSecondImage = fixImageUrl(secondImage)


  return (
    <Container
      className={clx(
        "relative group overflow-hidden rounded-2xl bg-white shadow hover:shadow-2xl transition-all duration-500",
        className,
        {
          "aspect-[11/14]": isFeatured,
          "aspect-[9/16]": !isFeatured && size !== "square",
          "aspect-[1/1]": size === "square",
          "w-[180px]": size === "small",
          "w-[290px]": size === "medium",
          "w-[440px]": size === "large",
          "w-full": size === "full",
        }
      )}
      data-testid={dataTestid}
    >
      {/* Etiqueta */}
<div
  className={clx(
    "absolute z-20 bg-yellow-500 text-black font-bold rounded-full",
    isCompact
      ? "top-2 left-2 text-[9px] px-2 py-1"
      : "top-3 left-3 text-xs px-3 py-1"
  )}
>
  NUEVO
</div>

      {/* Favorito */}
<button
  className={clx(
    "absolute z-20 rounded-full bg-white shadow flex items-center justify-center hover:bg-red-500 hover:text-white hover:scale-110 transition",
    isCompact
      ? "top-2 right-2 w-7 h-7 text-sm"
      : "top-3 right-3 w-10 h-10"
  )}
>
  ❤
</button>

      {/* Imagen principal */}
      <ImageOrPlaceholder image={fixedFirstImage} />

      {/* Segunda imagen */}
      {secondImage && (
        <Image
          src={fixedSecondImage!}
          alt=""
          fill
          className="absolute inset-0 object-cover opacity-0 group-hover:opacity-100 transition duration-500"
        />
      )}

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/45 opacity-0 group-hover:opacity-100 transition duration-300 flex flex-col items-center justify-center gap-4">

        <button className="bg-white text-black px-6 py-2 rounded-full font-semibold hover:bg-yellow-400 transition">
          👁 Vista rápida
        </button>

        <button className="bg-yellow-500 text-black px-6 py-2 rounded-full font-bold hover:bg-yellow-400 transition">
          🛒 Agregar
        </button>

      </div>
    </Container>
  )
}

const ImageOrPlaceholder = ({
  image,
}: {
  image?: string
}) => {
  return image ? (
   <Image
     src={image!}
    alt="Producto"
    fill
    quality={90}
    className="
        absolute
        inset-0
        object-cover
        transition-all
        duration-500
        group-hover:opacity-0
        group-hover:scale-110
    "
/>
  ) : (
    <div className="absolute inset-0 flex items-center justify-center">
      <PlaceholderImage size={24} />
    </div>
  )
}

export default Thumbnail
